class MobileProductAtc {
  constructor(element) {
    this.element = element;
    this.purchaseForm = document.querySelector(element.dataset.target);
    this.mobileQuery = window.matchMedia('(max-width: 749px)');

    if (!this.purchaseForm) return;

    this.onViewportChange = this.onViewportChange.bind(this);
    this.onQuantityChange = this.onQuantityChange.bind(this);

    this.quantityInputs = this.getQuantityInputs();
    this.quantityInputs.forEach((input) => {
      input.addEventListener('input', this.onQuantityChange);
      input.addEventListener('change', this.onQuantityChange);
    });

    this.mobileQuery.addEventListener('change', this.onViewportChange);
    this.onViewportChange();
  }

  getQuantityInputs() {
    return [this.purchaseForm.id, `${this.purchaseForm.id}--mobile`, `${this.purchaseForm.id}--alt`]
      .flatMap((id) => {
        const form = document.getElementById(id);
        return form ? Array.from(form.querySelectorAll('input[name="quantity"]')) : [];
      });
  }

  onViewportChange() {
    this.element.classList.toggle('is-visible', this.mobileQuery.matches);
  }

  onQuantityChange(event) {
    const quantity = event.target.value;
    if (quantity === '') return;

    this.quantityInputs.forEach((input) => {
      if (input !== event.target) input.value = quantity;
    });
  }
}

function initMobileProductAtc() {
  document.querySelectorAll('[data-mobile-product-atc]').forEach((element) => {
    if (!element.mobileProductAtc) {
      element.mobileProductAtc = new MobileProductAtc(element);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMobileProductAtc);
} else {
  initMobileProductAtc();
}
